import React from 'react';
import PopUp from '../../../../muiComponents/PopUp';

const DeletePopUp = props => {
    return (
        <PopUp
            titleText={'delete_sure'}
            {...props}
            saveButonProps={{ className: 'delete-button' }}
            saveText='delete'
        />
    );
};

export default DeletePopUp;
